import type { Classroom } from '@innovamat/radiance-utils';

import type { ClassroomStudent } from '../../views/classroom-students/types/classroom-student';
import { applyAvatarStageRules } from '../students/students';

const parseClassroomStudent = (
  student: ClassroomStudent,
  classroom: Classroom
): ClassroomStudent => ({
  ...student,
  avatar: applyAvatarStageRules(student, classroom.courseOrder),
});

const parseClassroomStudents = (
  students: ClassroomStudent[],
  classroom: Classroom
): ClassroomStudent[] =>
  students.map((student) => parseClassroomStudent(student, classroom));

export { parseClassroomStudents };
